import React from "react";

function IconPhone(data) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={data.w}
      height={data.h}
      viewBox="0 0 64 100"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fillRule="nonzero" transform="translate(-18)">
          <path
            fill="#000"
            d="M25 76h50V17H25v59zm-.143 24c-1.828 0-3.428-.682-4.8-2.045C18.686 96.59 18 95 18 93.182V6.818c0-1.818.686-3.409 2.057-4.773C21.43.682 23.03 0 24.857 0h50.286c1.828 0 3.428.682 4.8 2.045C81.314 3.41 82 5 82 6.818v86.364c0 1.818-.686 3.409-2.057 4.773-1.372 1.363-2.972 2.045-4.8 2.045H24.857zM25 10h50V7H25v3zm0-3v3-3zm0 76v10h50V83H25zm0 10V83v10z"
          ></path>
          <path
            fill="#FF8400"
            d="M49.5 92c1.011 0 1.847-.33 2.508-.992.661-.66.992-1.497.992-2.508s-.33-1.847-.992-2.508C51.348 85.33 50.511 85 49.5 85s-1.847.33-2.508.992c-.661.66-.992 1.497-.992 2.508s.33 1.847.992 2.508c.66.661 1.497.992 2.508.992z"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default IconPhone;
